var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDeactivate2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9267 20.1673C15.9683 20.1673 20.0933 16.0423 20.0933 11.0007C20.0933 5.95898 15.9683 1.83398 10.9267 1.83398C5.88501 1.83398 1.76001 5.95898 1.76001 11.0007C1.76001 16.0423 5.88501 20.1673 10.9267 20.1673Z",
    stroke: "#4E3E91",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 17.416L4.44498 4.51726",
    stroke: "#4E3E91",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45483 13.6751V8.32791C6.45483 6.72374 7.24088 5.6543 9.1231 5.6543H12.8662C14.7216 5.6543 15.5398 6.72374 15.5398 8.32791V13.0495L15.5451 13.6751C15.5451 15.2793 14.727 16.3487 12.8715 16.3487H9.12844C7.24088 16.3487 6.45483 15.2793 6.45483 13.6751Z",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85569 16.3314L8.85034 14.7433C8.85034 14.1497 9.32624 13.6738 9.91979 13.6738H12.064C12.6522 13.6738 13.1281 14.1497 13.1335 14.7379L13.1495 16.3367",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5833 8.74414H7.58325",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDeactivate2);
export default __webpack_public_path__ + "static/media/menu-deactivate2.7fb82aa58630ed6ad8564568cf54629e.svg";
export { ForwardRef as ReactComponent };